var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "analytics",
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.449 0c.35 0 .64.261.686.6l.006.093v17.711c0 .351-.26.64-.599.687l-.094.006h-4.427l-.023-.002-.022.002H.693a.693.693 0 0 1-.687-.599L0 18.404v-4.427c0-.351.26-.64.599-.687l.094-.006h3.734l.001-3.735c0-.316.211-.582.5-.666l.099-.02.094-.007h3.733l.001-3.735c0-.316.211-.582.5-.666l.099-.02.094-.007h3.779l.001-3.735c0-.316.21-.582.5-.666l.099-.02L14.02 0h4.428ZM4.427 14.668H1.385v3.042h3.042v-3.042Zm4.428-4.428H5.813v7.47h3.042v-7.47Zm4.427-4.427H10.24V17.71h3.042V5.813Zm4.473-4.427h-3.042V17.71h3.042V1.386Z",
    fill: "#264D6D",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.b9743e50aaad5b1e4f56b6be0dc51325.svg";
export { ForwardRef as ReactComponent };